import styled, {keyframes} from "styled-components"
import style from "@/style/style";
import React from "react";
import {IconDownArrow} from "@/components/icons";

const gradient = keyframes`
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`
export const Input = styled.input`
  outline: none !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-shadow: none !important;
  border: 1px solid ${style.colors.inpBorder};
  font-size: 14px;
  height: 38px !important;
  border-radius: 7px !important;
  padding: 6px 32px 6px 12px;
  color: ${style.colors.font} !important;
  width: 100%;
  box-sizing: border-box;

  &.isLoader__input {
    background: linear-gradient(-45deg, #fff, rgb(182, 181, 181), #fff);
    background-size: 400% 400%;
    animation: 2s ease none infinite running ${gradient};
  }


  &::-webkit-input-placeholder {
    color: inherit;
    opacity: 0.8;
    transition: opacity 0.3s;
    font-size: 13px;
    font-weight: 300;
    white-space: nowrap !important;
  }

  &::-moz-placeholder {
    color: inherit;
    opacity: 0.8;
    transition: opacity 0.3s;
    font-size: 13px;
    font-weight: 300;
  }

  &:-moz-placeholder {
    color: inherit;
    opacity: 0.8;
    transition: opacity 0.3s;
    font-size: 13px;
    font-weight: 300;
  }

  &:-ms-input-placeholder {
    color: inherit;
    opacity: 0.8;
    transition: opacity 0.3s;
    font-size: 13px;
    font-weight: 300;
  }

  &:disabled {
    background-color: #E9ECEF;
  }

  &:focus::-webkit-input-placeholder {
    opacity: 0;
  }

  &:focus::-moz-placeholder {
    opacity: 0;
  }

  &:focus:-ms-input-placeholder {
    opacity: 0;
  }

  &:hover {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: none !important;
    border: 1px solid  ${style.colors.inpBorder};;
  }

  &:focus {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: none !important;
    border: 1px solid ${style.colors.inpFocusBorder} !important;
  }

  &:active {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: none !important;
    border: 1px solid  ${style.colors.inpBorder};
  }
`

const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: auto auto auto;
`;

const Label = styled.div`
  font-size: 13px;
  color: ${style.colors.font};
  font-weight: 400;
  padding-bottom: 4px;
`
const Error = styled.div<{ $color: string }>`
  font-size: 11px;
  height: 16px;
  display: flex;
  align-items: flex-end;
  color: ${props => props.$color};
`

interface PropsInputLabel extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string,
    error?: string,
    colorError?: string,
    isLoading?: boolean
}

export const InputLabel = (props: PropsInputLabel): React.JSX.Element => {
    const {
        label,
        error,
        colorError,
        isLoading,
        ...other
    } = props;
    return (
        <Wrapper>
            <Label> {props.label}</Label>
            <Input {...other} className={isLoading ? 'isLoader__input' : ''}/>
            <Error $color={colorError}>{error}</Error>
        </Wrapper>
    )
}

const WrapperIconsDownMenu = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  right: 10px;
`;

const WrapperInputDown = styled.div`
  position: relative;
`;

interface PropsInputLabelDown extends PropsInputLabel {
    menu: string[]
}

export const InputLabelDown = (props: PropsInputLabelDown): React.JSX.Element => {
    const {
        label,
        error,
        colorError,
        isLoading,
        menu,
        ...other
    } = props;
    return (
        <Wrapper>
            <Label> {props.label}</Label>
            <WrapperInputDown>
                <Input {...other} className={isLoading ? 'isLoader__input' : ''}/>
                <WrapperIconsDownMenu> <IconDownArrow/> </WrapperIconsDownMenu>
            </WrapperInputDown>
            <Error $color={colorError}>{error}</Error>
        </Wrapper>
    )
}

